import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

// WW-169 · bottom sheet: scrim, grab handle, 44px close, scrim tap + Esc close, focus moves in.
export const BottomSheet = ({ title, pill, onClose, testId, children }) => {
  const ref = useRef(null);
  useEffect(() => {
    const prev = document.activeElement;
    ref.current?.focus();
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => { window.removeEventListener("keydown", onKey); prev?.focus?.(); };
  }, [onClose]);
  return createPortal(
    <div data-testid={`${testId}-root`} style={{ position: "fixed", inset: 0, zIndex: 1000 }}>
      <div data-testid={`${testId}-scrim`} onClick={onClose}
           style={{ position: "absolute", inset: 0, background: "rgba(10,10,26,0.6)" }} />
      <div ref={ref} tabIndex={-1} role="dialog" aria-modal="true" aria-label={title} data-testid={testId}
           className="ww-sheet"
           style={{ position: "absolute", left: 0, right: 0, bottom: 0, maxHeight: "85vh", overflowY: "auto",
                    margin: "0 auto", maxWidth: 640, borderRadius: "20px 20px 0 0", outline: "none",
                    background: "var(--ww-ground)", color: "var(--ww-text)", border: "1px solid var(--ww-line)",
                    padding: "8px 20px calc(28px + env(safe-area-inset-bottom))", animation: "ww-sheet-up 220ms ease-out" }}>
        <div aria-hidden style={{ width: 44, height: 5, borderRadius: 999, background: "var(--ww-line-strong)", margin: "4px auto 8px" }} />
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <h2 className="lowercase" style={{ flex: 1, fontFamily: "Poppins", fontWeight: 800, fontSize: 20, letterSpacing: "-0.02em" }}>{title}</h2>
          {pill && (
            <span data-testid={`${testId}-pill`} style={{ fontFamily: "Arial", fontSize: 11, fontWeight: 700, padding: "4px 10px",
                         borderRadius: 999, border: "1px solid var(--ww-line-strong)", color: "var(--ww-text-muted)" }}>{pill}</span>
          )}
          <button type="button" aria-label="close" data-testid={`${testId}-close`} onClick={onClose}
                  style={{ width: 44, height: 44, borderRadius: 999, display: "grid", placeItems: "center",
                           background: "transparent", border: "1px solid var(--ww-line)", color: "var(--ww-text)", cursor: "pointer" }}>
            <X size={18} />
          </button>
        </div>
        {children}
      </div>
    </div>,
    document.body,
  );
};
